<template>
  <div class="page-body overflow-visible">
    <template v-if="isBusy || (items && items.length > 0)">
      <div class="page-table-container overflow-visible">
        <b-table
          id="location-works"
          ref="location_works"
          class="custom-table mb-0"
          :busy.sync="isBusy"
          :items="items"
          :fields="fields"
          :current-page="currentPage"
          :per-page="perPage"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          :sort-compare="sortCompare"
          no-provider-filtering
          no-provider-paging
          no-provider-sorting
        >
          <template #table-busy>
            <div class="text-center text-success my-2">
              <b-spinner class="align-middle"/>
              <strong>Загрузка</strong>
            </div>
          </template>

          <template #cell(work_type)="row">
            <work-type-select
              id="work-type-select"
              ref="work_type_select"
              :is-disabled="isDisabled"
              @onSelect="onSelectWorkType($event, row)"
              :value="row.item.work_type_id"
            />
          </template>

          <template #cell(rate)="row">
            <b-form-input
              id="input-rate"
              size="sm"
              :disabled="isDisabled"
              autocomplete="off"
              type="number"
              v-model.number="row.item.rate"
            />
          </template>

          <template #cell(unit)="row">
            <unit-select
              id="input-unit"
              ref="unit_select"
              :is-disabled = "isDisabled"
              :initial-unit="row.item.unit_code"
              is-short
              @selectUnit="onSelectUnit($event, row)"
            />
          </template>

          <template #head(action)="row">
            <b-btn variant="link" style="color: #1A9167 !important; text-decoration: none !important;" :disabled="isDisabled" @click.stop="onAdd()">
              <v-icon name="buttons/plus" :size="12" class="mr-1"/>
              Добавить
            </b-btn>
          </template>

          <template #cell(action)="row">
            <b-button variant="link" @click="onRemove(row)" :disabled="isDisabled">
              <v-icon name="buttons/trash" :size="16"/>
            </b-button>
          </template>
        </b-table>
      </div>

      <div class="page-pagination">
        <pagination-footer
          :total-rows="items.length"
          :per-page="perPage"
          :current-page.sync="currentPage"
          @per-page-change="onPerPageChange"
        />
      </div>
    </template>

    <div v-else class="empty-state-container">
      <v-icon name="navbar/empty_table" :size="90"/>
      <h5>Нет добавленных работ.</h5>
      <p>Добавьте работы объекта прямо сейчас</p>
      <b-btn class="custom-btn-primary mt-1" :disabled="isDisabled" @click.stop="onAdd()">
        <v-icon name="buttons/plus" :size="12" class="mr-1"/>
        Новая работа
      </b-btn>
    </div>
  </div>
</template>

<script>
import helpers from "../../utilites/helpers";
import PaginationFooter from "../../utilites/commonUi/PaginationFooter.vue";
  import WorkTypeSelect from "../Catalogs/WorkType/WorkTypeSelect";
  import UnitSelect from "../Catalogs/UnitSelect";

export default {
  name: "LocationWorks",
  components: {PaginationFooter, WorkTypeSelect, UnitSelect },
  mixins: [ helpers ],
  props: {
    isDisabled: Boolean
  },
  data() {
    return {
      locationId: 0,
      isBusy: false,
      items: [],
      perPage: 10,
      currentPage: 1,
      fields: [
        {
          key: 'work_type',
          label: 'Вид работ',
          sortable: false
        },
        {
          key: 'rate',
          label: 'Стоимость работ',
          class: 'location-works-width',
          sortable: false
        },
        {
          key: 'unit',
          label: 'Ед. изм.',
          class: 'location-works-width',
          sortable: false
        },
        {
          key: 'action',
          label: "Действия",
          class: 'location-works-action',
          tdClass: 'align-bottom',
          sortable: false
        },
      ],
      deleteRow: {
        id: null,
        work_type_name: ''
      },
      sortBy: 'id',
      sortDesc: true,
    }
  },
  methods: {
    configure(locationId, items) {
      this.items = items;
      this.locationId = locationId;
    },
    onAdd() {
      const data = {
        id: 0,
        work_type_id: 0,
        work_type_name: '',
        rate: 0,
        unit_code: '539',
      };
      this.items.unshift(data);
      this.currentPage = 1;
    },
    onRemove(row) {
      if (row.item) {
        this.deleteRow = row.item;
      }
      const title = "Удаление работы";
      const message = `Вы уверены, что хотите удалить ${this.deleteRow.work_type_name.toLowerCase()}?`;
      this.showModalDelete(title, message, function () {
        const index = this.items.findIndex(item => item === row.item);
        this.items.splice(index, 1);
      }.bind(this));
    },
    onSelectWorkType(workType, row) {
      if (workType != null) {
        row.item.work_type_id = workType.id;
        row.item.work_type_name = workType.name;
      } else {
        row.item.work_type_id = 0;
        row.item.work_type_name = "";
      }
    },
    // Единицы измерения
    onSelectUnit(unit, row) {
      row.item.unit_code = unit.code;
    },
    onPerPageChange(newPerPage) {
      this.perPage = Number(newPerPage);
      this.currentPage = 1;
    },
  }
}
</script>

<style >
.location-works-width {
  width: 200px;
}

.location-works-action {
  width: 140px;
}

#location-works td {
  text-align: center;
}

#location-works th {
  text-align: center;
  vertical-align: middle;
}
</style>



// WEBPACK FOOTER //
// src/components/Locations/LocationWorks.vue